export const HintBullet = () => {
  return <span className="h-2 w-2 rounded-full bg-lds-element-primary" />;
};
